import React, { Component } from 'react';
import './label.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';



class Label extends Component {
    constructor(props) {
      super(props);
      // State is in reducers
        this.state = {
            term:"",
        };

  }
  
  
  // ---------------------RENDER --------------------- 
  render() {
    var labelStyle = {color: this.props.config.color, textAlign:this.props.config.textAlign};

      return (
          <div className={"label "+this.props.config.additionalClass} style={labelStyle}>
              <span style={labelStyle} className="icon">
                {this.props.config.icon !== undefined ?
                  <FontAwesomeIcon icon={this.props.config.icon}/>:null
                }
              </span>
              <span style={labelStyle} className="text">{this.props.config.text}</span>
          </div>
      );
  }
}
  
const mapStateToProps = (state) => {    
  return {  
    
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(Label);
  